<!-- eslint-disable @angular-eslint/template/no-call-expression -->
@if (messages?.length) {
  <div class="snackbar" [ngStyle]="snackbarStyle()">
    <div class="d-flex justify-content-end">
      <div class="snackbar-header" (click)="toggle()">
        <div>
          <svg class="icon icon-18 color-secondary" height="100%" viewBox="0 0 36 36" width="100%">
            <g fill="none" stroke-width="3" transform="translate(-160.425 -551.881)">
              <ellipse cx="178.425" cy="569.881" rx="16.755" ry="16.755" stroke="currentColor" />
              <path d="M174.644 567.405h4.677v12.917" stroke="currentColor" />
              <ellipse cx="178.683" cy="561.828" rx="1.011" ry="1.018" stroke="currentColor" />
            </g>
          </svg>
        </div>
        <div class="ml-2 text-color-primary text-size-small">{{ 'snackbar.header' | transloco }}</div>
      </div>
    </div>
    <div class="snackbar-content" #snackbarContent>
      <div class="snackbar-close" (click)="clearAndClose()">
        <svg class="icon icon-18 icon-inactive" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" height="100%" width="100%">
          <path
            d="M437.5 386.6L306.9 256l130.6-130.6c14.1-14.1 14.1-36.8 0-50.9-14.1-14.1-36.8-14.1-50.9 0L256 205.1 125.4 74.5c-14.1-14.1-36.8-14.1-50.9 0-14.1 14.1-14.1 36.8 0 50.9L205.1 256 74.5 386.6c-14.1 14.1-14.1 36.8 0 50.9 14.1 14.1 36.8 14.1 50.9 0L256 306.9l130.6 130.6c14.1 14.1 36.8 14.1 50.9 0 14-14.1 14-36.9 0-50.9z"
          />
        </svg>
      </div>

      @for (msg of messages; track msg.id) {
        @switch (msg.type) {
          @case (messageTypes.order) {
            <web-components-snackbar-order-msg [order]="msg.msgData" />
          }
          @case (messageTypes.msg) {
            <web-components-snackbar-msg [msg]="msg.msg" [msgDetail]="msg.msgData" />
          }
          @case (messageTypes.ticket) {
            <web-components-snackbar-ticket-msg [pushMsg]="msg" />
          }
        }
      }

      @if (orderMessagesPresent()) {
        <div class="d-flex align-items-center justify-content-center">
          <a [routerLink]="memberHome" class="link link-secondary" (click)="toggle()">{{ 'snackbar.depot' | transloco }}</a>
        </div>
      }
    </div>
  </div>
}
